/* MUI */
import { Grid, Paper } from '@mui/material';

/* Shared */
import { PageTitle } from 'application/Shared/Components/App';
import { AdminBackButton } from 'application/Shared/Components/Buttons/BackButton';
import 'application/Shared/Helpers';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';

import DeploymentPolicies from './Policies';

export const AdminExtension = () => {
    const { t } = useTranslation();
    return (
        <>
            <PageTitle title={t('PartnerDeployment.browser_agent')} />
            <AdminBackButton linkTo="/configure" />
            <Paper elevation={0} variant="outlined">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <DeploymentPolicies />
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
};
